module.exports = __webpack_public_path__ + "static/media/201EE172.644843fb.jpg";